"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@xefi/x-react/button";
import { useDisclosure } from "@xefi/x-react/hooks";
import { IconFileImport } from "@xefi/x-react/icons";
import { useTranslation } from "react-i18next";
import ImportModal from "./ImportModal";
export default function ImportButton() {
  const $ = _c(12);
  const {
    t
  } = useTranslation();
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconFileImport size={16} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("paymentsReceived.actions.import");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onOpen || $[4] !== t1) {
    t2 = <Button color="primary" size="sm" radius="sm" onClick={onOpen} startContent={t0}>{t1}</Button>;
    $[3] = onOpen;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isOpen || $[7] !== onClose) {
    t3 = <ImportModal isOpen={isOpen} onClose={onClose} />;
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}